import React from "react";
import TimeDropdown from "./TimeDropdown";

const SubTitle = ({ title, showDropdown, heading }) => {
  return (
    <div className="flex justify-between items-center bg-[#e1f6f9] rounded-t-md px-4 py-2">
      <h6 className="text-md font-medium">{title}</h6>
      {showDropdown === true && <TimeDropdown heading={heading} />}
    </div>
  );
};

export default SubTitle;
